import { Space, Table, Button,Input,Empty } from 'antd';
import type { TableProps } from 'antd';
import { DataType,column } from './column';
import { userList } from "@/services/user/user"
import dayjs from 'dayjs';
import useSearchTable from '@/hooks/useList';

export default function UsersPage() {
  const defaultValue = {
    Mobile: '',
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(userList, defaultValue );
  
  const search = (e:any)=>{
    handleSearch({Mobile: e.target.value})
  }

  const columns: TableProps<DataType>['columns'] = [
    ...column,
    {
      title: '注册/上次登录',
      key: 'registerAndLogin',
      render: (_, row) => (
        <>
          <p>注册：{row.registerTime && dayjs(row.registerTime).format("YYYY-MM-DD HH:mm:ss")}</p>
          <p>登录：{row.lastLoginTime && dayjs(row.lastLoginTime).format("YYYY-MM-DD HH:mm:ss")}</p>
        </>
      ),
    }
  ];


  return (
    <>
      
      <div className="headerTitle">
        <div>
          <h2>用户管理</h2>
        </div>
      </div>

      <div className="card">
        <div className="mb-4 flex flex-col md:flex-row gap-4">
          <div className="searchCond">
            <Space size='middle'>
              <Input style={{ width:'250px' }} allowClear placeholder="手机号" onPressEnter={search} size='large' onChange={search}/>
                <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
            </Space>
          </div>
        </div>
            
        <Table
          rowKey='id'
         columns={columns} 
         dataSource={data as DataType[]}
         loading={loading}
         pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
         scroll={{ x: 'max-content', y: 580 }}
         locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
        />
       
      </div>
      </>
  );
} 